import { render, staticRenderFns } from "./SideBarSales.vue?vue&type=template&id=446b3610"
import script from "./SideBarSales.vue?vue&type=script&lang=js"
export * from "./SideBarSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports